import '@/registerServiceWorker'
import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'
import '@fortawesome/fontawesome-free/css/regular.min.css'
import '@fortawesome/fontawesome-free/css/brands.min.css'
import 'vue-transition-expand/dist/vue-transition-expand.css'
import 'swiper/swiper-bundle.min.css'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'

import {Setup} from '@/app/Setup'

Setup.init()
